export const SEND_CONTACT_INFO = 'SEND_CONTACT_INFO'
export const SEND_CONTACT_INFO_SUCCESS = 'SEND_CONTACT_INFO_SUCCESS'
export const SEND_CONTACT_INFO_FAILURE = 'SEND_CONTACT_INFO_FAILURE'

export const UPDATE_LOCAL = 'UPDATE_LOCAL'
export const CONTACT_INFO_REQUEST_CLEAR = 'CONTACT_INFO_REQUEST_CLEAR'
